var map = {
	"./ak-sigorta.png": "fad6",
	"./allianz-sigorta.png": "565c",
	"./ankara-sigorta.png": "992a",
	"./atlas-mutuel-sigorta.png": "ae8a",
	"./axa-sigorta.png": "4d1b",
	"./bereket-sigorta.png": "ce45",
	"./demir-sigorta.png": "8a14",
	"./fiba-emeklilik.png": "b90b",
	"./generali-sigorta.png": "1043",
	"./groupama-sigorta.png": "3e47",
	"./hdi-sigorta.png": "e394",
	"./mapfre-sigorta.png": "ef42",
	"./quick-sigorta.png": "8f31",
	"./ray-sigorta.png": "a60e",
	"./sompo-sigorta.png": "88b8",
	"./turk-nippon-sigorta.png": "c2f8",
	"./turkiye-sigorta.png": "8281",
	"./unico-sigorta.png": "35f9",
	"./zurich-sigorta.png": "5595"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8d33";